<template>
  <div
    class="profit-and-loss-report-table"
  >
    <div
      v-for="pnlData in sortedTableData"
      :key="pnlData.key"
      :class="reportElement.classes"
    >
      <div class="text-h6 ellipsis">
        {{ pnlData.key }}
      </div>
      <profit-and-loss-table
        :pnl-data="convertToPnlData(pnlData.key, pnlData)"
      />
    </div>
  </div>
</template>

<script>

import PnlData from 'src/models/pnl-data/PnlData'
import { internalSort } from 'src/models/report/ReportTable'
import ProfitAndLossTable from 'src/modules/admin/showing/ProfitAndLossTable'

export default {
  name: 'ProfitAndLossReportTable',
  components: { ProfitAndLossTable },
  props: {
    table: {
      type: Object,
      required: true
    },
    reportElement: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      computedPnlData: {}
    }
  },
  computed: {
    sortedTableData () {
      return internalSort(this.table.tableData, this.table.sortBy, this.table.descending)
    }
  },
  watch: {
    table: {
      handler () {
        _.each(Object.values(this.computedPnlData), pnlData => pnlData.destroy())
        this.computedPnlData = {}
      },
      deep: true
    }
  },
  methods: {
    convertToPnlData (key, tableData) {
      if (!this.computedPnlData[key]) {
        this.computedPnlData[key] = PnlData.fromShowingMetrics(tableData)
      }
      return this.computedPnlData[key]
    }
  }
}
</script>

<style lang="scss" scoped>
.profit-and-loss-report-table {
  text-align: left;
}
</style>
